export const setUserDetails = (token: string) => {
  return localStorage.setItem("user", JSON.stringify(token));
};

export const getUserDetails = () => {
  const getUser = localStorage.getItem("user");
  if (!getUser) {
    return null;
  }
  return JSON.parse(getUser);
};

export const removeUser = () => {
  return localStorage.removeItem("user");
};
